import { render, staticRenderFns } from "./setupModal.vue?vue&type=template&id=4edbeed2"
import script from "./setupModal.vue?vue&type=script&lang=js"
export * from "./setupModal.vue?vue&type=script&lang=js"
import style0 from "./setupModal.vue?vue&type=style&index=0&id=4edbeed2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports